// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"53":"app-messages-Spanish_Ext","139":"app-messages-en_US","225":"app-messages-ChineseWu_Ext","881":"product-metadata"}[chunkId] + "." + {"53":"f75ba240","139":"b68fd7ad","225":"7da47dd2","881":"dd46f504"}[chunkId] + ".chunk.js";
};